export default __webpack_public_path__ + "static/media/Head_5_Ear_2_C2.f59ed7ef.svg";